import emailjs from '@emailjs/browser'

const SERVICE_ID = import.meta.env.VITE_EMAILJS_SERVICE_ID ?? ''
const TEMPLATE_ID = import.meta.env.VITE_EMAILJS_TEMPLATE_ID ?? ''
const PUBLIC_KEY = import.meta.env.VITE_EMAILJS_PUBLIC_KEY ?? ''

export const isEmailConfigured = () => !!(SERVICE_ID && TEMPLATE_ID && PUBLIC_KEY)

export interface OrderEmailParams {
  to_email: string
  to_name: string
  order_num: number | string
  items_text: string
  total_text: string
  address: string
}

/**
 * Sends the order confirmation email straight from the browser via EmailJS —
 * no backend/server needed. Requires an EmailJS account: sign up at
 * emailjs.com, connect an email service (Gmail etc.), create a template with
 * these variables: {{to_email}} {{to_name}} {{order_num}} {{items_text}}
 * {{total_text}} {{address}} — then put the 3 IDs it gives you into .env:
 * VITE_EMAILJS_SERVICE_ID, VITE_EMAILJS_TEMPLATE_ID, VITE_EMAILJS_PUBLIC_KEY
 */
export async function sendOrderConfirmationEmail(params: OrderEmailParams): Promise<{ ok: boolean; message?: string }> {
  if (!isEmailConfigured()) {
    return { ok: false, message: 'EmailJS nije podešen (nedostaju VITE_EMAILJS_* u .env) — porudžbina je sačuvana, ali mejl nije poslat.' }
  }
  try {
    await emailjs.send(SERVICE_ID, TEMPLATE_ID, { ...params }, { publicKey: PUBLIC_KEY })
    return { ok: true }
  } catch (e) {
    const message = e instanceof Error ? e.message : (typeof e === 'object' && e && 'text' in e ? String((e as { text: unknown }).text) : 'Nepoznata greška pri slanju mejla.')
    return { ok: false, message }
  }
}
